module.exports = "/images/not-dashboard.svg?020142a4206935ba5aaf7cace48e3614";